import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const SLOT_MINUTES = 10;
export const DEFAULT_DURATION = 10;
export const DURATION_OPTIONS = [10, 20, 30, 45, 60];

export const DurationSelect = ({ value, onChange, testId, className = '' }) => (
  <Select value={String(value || DEFAULT_DURATION)} onValueChange={(v) => onChange(Number(v))}>
    <SelectTrigger className={className} data-testid={testId}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {DURATION_OPTIONS.map((d) => (
        <SelectItem key={d} value={String(d)} data-testid={`${testId}-option-${d}`}>{d} min</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
